import { useState } from 'react';
import { DETOX_PROMPTS, DIFFICULTY_OPTIONS } from '../../lib/detoxPrompts';

export default function DetoxCheckIn({ currentDay, todayCheckin, communityCount, onCheckIn }) {
  const promptData = DETOX_PROMPTS.find(p => p.day === currentDay);
  const [stayedOff, setStayedOff]     = useState(todayCheckin?.stayed_off ?? null);
  const [difficulty, setDifficulty]   = useState(todayCheckin?.difficulty ?? null);
  const [craving, setCraving]         = useState(todayCheckin?.craving_score ?? 5);
  const [reflection, setReflection]   = useState(todayCheckin?.reflection ?? '');
  const [saved, setSaved]             = useState(!!todayCheckin);
  const [loading, setLoading]         = useState(false);

  const handleSave = async () => {
    if (stayedOff === null || !difficulty) return;
    setLoading(true);
    const { error } = await onCheckIn({
      stayedOff,
      difficulty,
      cravingScore: craving,
      reflection,
    });
    setLoading(false);
    if (!error) setSaved(true);
  };

  if (!promptData) return null;

  return (
    <div className="detox-checkin">
      {/* Day header */}
      <div className="detox-day-header">
        <span className="detox-day-emoji">{promptData.emoji}</span>
        <div>
          <p className="detox-day-label">Dia {currentDay} de 7</p>
          <h2 className="detox-day-theme">{promptData.theme}</h2>
        </div>
      </div>

      {communityCount > 0 && (
        <div className="detox-community-pill">
          🔥 {communityCount} {communityCount === 1 ? 'pessoa está' : 'pessoas estão'} no detox hoje
        </div>
      )}

      {/* Prompt */}
      <div className="card detox-prompt-card">
        <p className="card-title">Prompt do dia</p>
        <p className="detox-prompt-text">"{promptData.prompt}"</p>
      </div>

      {/* Ficou sem redes? */}
      <div className="card">
        <p className="card-title">📵 Você ficou sem redes hoje?</p>
        <div className="detox-yesno">
          <button
            className={`detox-yesno-btn ${stayedOff === true ? 'selected yes' : ''}`}
            onClick={() => !saved && setStayedOff(true)}
            disabled={saved}
          >
            ✅ Sim, consegui!
          </button>
          <button
            className={`detox-yesno-btn ${stayedOff === false ? 'selected no' : ''}`}
            onClick={() => !saved && setStayedOff(false)}
            disabled={saved}
          >
            😅 Não dessa vez
          </button>
        </div>
      </div>

      {/* Dificuldade */}
      <div className="card">
        <p className="card-title">Como foi a dificuldade?</p>
        <div className="difficulty-options">
          {DIFFICULTY_OPTIONS.map(opt => (
            <button
              key={opt.value}
              className={`difficulty-btn ${difficulty === opt.value ? 'selected' : ''}`}
              onClick={() => !saved && setDifficulty(opt.value)}
              disabled={saved}
            >
              <span className="difficulty-emoji">{opt.emoji}</span>
              <span>{opt.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Craving score */}
      <div className="card">
        <p className="card-title">
          Quantas vezes sentiu vontade de abrir as redes? — <strong>{craving}x</strong>
        </p>
        <input
          type="range"
          min={0}
          max={20}
          value={craving}
          onChange={e => !saved && setCraving(Number(e.target.value))}
          disabled={saved}
          className="craving-slider"
        />
        <div className="craving-labels">
          <span>0x — Zero vontade</span>
          <span>20x — Vontade constante</span>
        </div>
      </div>

      {/* Reflection */}
      <div className="card">
        <p className="card-title">✍️ Sua reflexão do dia</p>
        <textarea
          className="input"
          rows={5}
          placeholder="Escreva livremente sobre o prompt acima..."
          value={reflection}
          onChange={e => !saved && setReflection(e.target.value)}
          disabled={saved}
          style={{ fontSize: '16px' }}
        />
      </div>

      {!saved ? (
        <button
          className="btn btn-primary detox-start-btn"
          onClick={handleSave}
          disabled={stayedOff === null || !difficulty || loading}
        >
          {loading ? 'Salvando...' : `Registrar Dia ${currentDay} ✅`}
        </button>
      ) : (
        <div className="detox-saved-msg">
          🌟 Dia {currentDay} registrado! Volte amanhã para continuar.
        </div>
      )}
    </div>
  );
}
